import { render } from "./sku.vue?vue&type=template&id=7632c073&scoped=true&ts=true"
import script from "./sku.vue?vue&type=script&lang=ts"
export * from "./sku.vue?vue&type=script&lang=ts"

import "./sku.vue?vue&type=style&index=0&id=7632c073&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7632c073"]])

export default __exports__